export enum ManDaysRegisterMode {
  NEVER = 1,
  SEPARATE_ATTACHMENT = 2,
  IN_STATEMENT_PDF = 3
}
